<div>
  <p class="spacing--none ag-cell-fund-name" *ngIf="isSoftLaunch || !fundLink">
    {{ fundName }}
  </p>
  <!-- 
    DCE-2334
    1. Active : Show in grid and take user to product page
    2. Soft Launch : Show in Grid but disable product page link	
    3. Inactive: Do not show in grid	
    4. Soft Closed: Do not show in grid
   -->
  <p class="spacing--none ag-cell-fund-name" *ngIf="!isSoftLaunch">
    <eds-link-item
      *ngIf="fundLink"
      class="ag-cell-frk--link"
      [href]="fundLink"
      eventId="linkOrButtonClick"
    >
      {{ fundName }}
    </eds-link-item>
  </p>
  <eds-notifications
    *ngIf="actualsAlert"
    [title]="'products.capgains-fund-alert' | translate"
    [notificationType]="notificationType"
    [inline]="true"
    [small]="true"
  ></eds-notifications>
</div>
